import {createClient} from "contentful";

export default createClient({
    space: "qgdrdexwf7gx",
    accessToken:"ucPM8rqbRdnpEu0ZK1lyipb-igV-p0XWvPUPlaiGgbY"
})